import { string, number, object } from 'prop-types';

import ContentLoader from 'components/utility/ContentLoader/ContentLoader';
import TableCell from 'components/data-visualization/Table/Cell';
import TableRow from 'components/data-visualization/Table/Row';

/**
 * Renders a few grey boxes, like the no-data placeholder, which mimic table cell content,
 * these boxes are color animated to indicate loading activity.
 * @param {number} columnCount the number of columns of the table in which the placeholder will be rendered
 * @param {object} cellComponent component name for the cell, defaults to TableCell
 * @param {object} rowComponent component name for the row, defaults to TableRow
 */
const TableLoader = (props) => {
  const {
    columnCount,
    className,
    cellComponent: CellComponent = TableCell,
    rowComponent: RowComponent = TableRow,
    rowCount = 3,
  } = props;

  return (
    <>
      {Array(rowCount)
        .fill()
        .map((val, index) => (
          <RowComponent
            enableHover={false}
            key={`playlist-table-loader-${index}`}
          >
            <CellComponent colSpan={columnCount}>
              <ContentLoader width={200} height={37} className={className}>
                <rect width="125" height="15" x="0" y="4" />
                <rect width="200" height="10" x="0" y="25" />
              </ContentLoader>
            </CellComponent>
          </RowComponent>
        ))}
    </>
  );
};

TableLoader.propTypes = {
  /** Used by styled components */
  className: string,
  /** The number of columns the loader should span */
  columnCount: number,
  /** The component rendering the Row */
  rowComponent: object,
  cellComponent: object,
  /** The number of rows the loader should span */
  rowCount: number,
};

/** @component */
export default TableLoader;
